export default __webpack_public_path__ + "static/media/translate.88d7e99d.svg";